import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ef0ff962"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef0ff962')) {
      api.createRecord('ef0ff962', component.options)
    } else {
      api.reload('ef0ff962', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=ef0ff962", function () {
      api.rerender('ef0ff962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/type_7/Footer.vue"
export default component.exports